export interface TGlobalState {
  loaderStep: number
}

export enum ActionTypes {
  SET_LOADER = '@@global/SET_LOADER',
}
